import React from 'react';
// Helper to check equality between two focused indexes
export function focusedIndexEquals(a, b) {
    if (a === null || b === null)
        return a === b;
    return a.parent === b.parent && a.child === b.child;
}
// Convert to string for DOM data-attribute (needed for querySelector)
export function focusedIndexToString(idx) {
    return idx.child !== undefined ? `${idx.parent}.${idx.child}` : `${idx.parent}`;
}
export const NavigatableListStateContext = React.createContext(null);
export const NavigatableListUpdateContext = React.createContext(null);
export const NavigatableRegistrationContext = React.createContext(null);
export function useNavigatableListState() {
    const context = React.useContext(NavigatableListStateContext);
    if (context === null) {
        throw new Error('useNavigatableListState must be used within a NavigatableList');
    }
    return context;
}
export function useNavigatableListUpdate() {
    const context = React.useContext(NavigatableListUpdateContext);
    if (context === null) {
        throw new Error('useNavigatableListUpdate must be used within a NavigatableList');
    }
    return context;
}
export function useNavigatableRegistration() {
    const context = React.useContext(NavigatableRegistrationContext);
    if (context === null) {
        throw new Error('useNavigatableRegistration must be used within a NavigatableList');
    }
    return context;
}
